<template>
    <span>
        <template v-if="showMinusSignForZeroValue">
            <span v-if="alwaysShowSign && number > 0">+</span>
            <span v-if="number <= 0">-</span>
        </template>
        <template v-else>
            <span v-if="alwaysShowSign && number >= 0">+</span>
            <span v-if="number < 0">-</span>
        </template>
        {{
            Math.abs(computedNumber).toLocaleString(undefined, {
                minimumFractionDigits: minimumFractionDigits,
                maximumFractionDigits: maximumFractionDigits
            })
        }}
    </span>
</template>

<script>
export default {
    name: "NiceDecimalNumber",
    props: {
        number: {
            required: true
        },
        maximumFractionDigits: {
            type: Number,
            default: 2
        },
        minimumFractionDigits: {
            type: Number,
            default: 2
        },
        alwaysShowSign: {
            type: Boolean,
            default: false
        },
        showMinusSignForZeroValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedNumber() {
            if (!this.number) {
                return 0
            } else {
                return parseFloat(this.number)
            }
        }
    }
}
</script>

<style scoped>

</style>
